/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import styles from "./../../sass/landing/news.module.scss";
import classNames from "classnames";
//import MailchimpSubscribe from "react-mailchimp-subscribe"
import { useForm, Controller } from "react-hook-form";
import { Button, TextField, Alert, Skeleton, Link } from "@mui/material";
import img1 from "./../../Landing/assets/misc/1.png";
import img2 from "./../../Landing/assets/misc/2.png";
import img3 from "./../../Landing/assets/misc/3.png";
import img4 from "./../../Landing/assets/misc/4.png";
import IconButton from "./IconButton";
import { ArrowRightCircleOutline } from "mdi-material-ui";

export const CustomForm = ({ status, message, onValidated, extraFields, submitButtonLabel, successUrl, onSuccess }) => {

  // state
  const [response, setResponse] = useState("");
  const [feedback, setFeedback] = useState("");

  // misc hooks
  const { handleSubmit, control, errors, setValue } = useForm();

  // lifecycles
  useEffect(() => {
    setResponse(status);
    setFeedback(message);
    if(status === "success") {
      setValue("email", "");
      if(extraFields) {
        setValue("name", "");
      }
    }
  },[status,message]);

  useEffect(() => {
    if(response === "success" && successUrl) {
      window.open(successUrl);
      localStorage.setItem("subbed", true);
      onSuccess();
    }
  },[response]);

  const submit = (form) => {
    if(extraFields) {
      onValidated({
        EMAIL: form.email,
        FNAME: form.name,
      });
      return;
    }
    onValidated({
      EMAIL: form.email,
    });
  }

  return (
    <form
      onSubmit={handleSubmit(submit)}
    >
      {
        extraFields && (
          <Controller
            as={
              <TextField
                label="Name"
                autoComplete="new-password"
                fullWidth={true}
                variant="outlined"
                error={errors.name && true}
                helperText={errors?.name?.message}
                className="mb-3 mt-2"
                inputProps={{ maxLength: 30 }}
              />
            }
            name="name"
            control={control}
            defaultValue={""}
            rules={{
              required: "This field is required.",
            }}
          />
        )
      }
      <Controller
        as={
          <TextField
            label="E-mail"
            autoComplete="new-password"
            fullWidth={true}
            variant="outlined"
            error={errors.email && true}
            helperText={errors?.email?.message}
            className="mb-3"
            inputProps={{ maxLength: 30 }}
          />
        }
        name="email"
        control={control}
        defaultValue={""}
        rules={{
          required: "This field is required.",
          pattern: {
            value:
              /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i,
            message: "Please enter a valid email address.",
          },
        }}
      />
      {
        response === "error" && (
          <Alert severity="error" className="mb-3">
            {feedback}
          </Alert>  
        )
      }
      {
        response === "success" && (
          <Alert severity="success" className="mb-3">
            {feedback}
          </Alert>  
        )
      }
      <Button
        disabled={response === "sending"}
        size="large"
        variant="contained"
        color="primary"
        type="submit"
      >
        {submitButtonLabel ? submitButtonLabel : "Subscribe"}
      </Button>
    </form>
  )
}

const News = () => {

  // state
  const [loading, setLoading] = useState(true);
  const [posts, setPosts] = useState(staticPosts);

  // lifecycles
  useEffect(() => {
    handleGetPosts();
  },[]);

  // methods
  const handleGetPosts = async () => {
    /*
    const [error, response] = await getPosts();
    setLoading(false);
    if(error) {
      return;
    }
    */
    setPosts(staticPosts);
    setLoading(false);
  }

  return (
    <div className={classNames(styles["news"])}>
      <div className="container">
        <div className="row">
          <div className="col-12 text-center">
            <h3>Featured In</h3>
          </div>
          {
            loading ? (
              <div className="col-12">
                <Skeleton variant="text"/>
                <Skeleton variant="text"/>
                <Skeleton variant="text"/>
              </div>
            ) : (
              <>
                {
                  posts.length === 0 ? (
                    <div className="col-12 h-100">
                      No News
                    </div>
                  ) : (
                    <>
                      {
                        posts.map((post) => {
                          return (
                            <div className="col-xl-3 col-lg-6 mb-3 text-center" key={Math.random()}>
                              <img src={post.img} className="img-fluid" alt="Thumbnail"/>
                              <p className={classNames(styles["source"])}>
                                {post.source}
                              </p>
                              <Button 
                                variant="text" 
                                component={Link} 
                                href={post.link} 
                                target="_blank"
                                size="large"
                                >Read Now <ArrowRightCircleOutline/>
                              </Button>
                            </div>
                          )
                        })
                      }
                    </>
                  )
                }
              </>
            )
          }
        </div>
        <div className="row d-none">
          <div className="col-12 d-flex justify-content-center mt-5">
            <IconButton copy={"View All"} icon="news" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default News;

const staticPosts = [{
  img: img1,
  source: "Benefits Canada",
  title: "DB pension plans not taking full advantage of agricultural carbon savings: expert",
  link: "https://www.benefitscanada.com/news/cir-news-news/db-pension-plans-not-taking-full-advantage-of-agricultural-carbon-savings-expert/",
}, {
  img: img2,
  source: "The Nation",
  title: "Kenya set to reap from new carbon market initiative",
  link: "https://nation.africa/kenya/news/kenya-set-to-reap-from-new-carbon-market-initiative-4014892"
}, {
  img: img4,
  source: "Earth Journalism",
  title: "Kenya Set to Reap From New Carbon Market Initiative",
  link: "https://earthjournalism.net/stories/kenya-set-to-reap-from-new-carbon-market-initiative"
}, {
  img: img3,
  source: "Yahoo Finance",
  title: "BlueSphere Carbon Chairman Talks Emerging Carbon Markets",
  link: "https://finance.yahoo.com/news/exclusive-bluesphere-carbon-chairman-talks-160000104.html"
}];
